module.exports = __webpack_public_path__ + "img/solAr.b78d5484.png";